/**
 * ScoresTicker - Displays live scores in a horizontal ticker format.
 * This is a placeholder implementation that will be enhanced with real data.
 */
import React, { useState, useEffect } from 'react';

// Placeholder data - will be replaced with real API
const PLACEHOLDER_SCORES = [
    { id: 1, homeTeam: 'Lakers', awayTeam: 'Celtics', homeScore: 105, awayScore: 98, status: 'Final' },
    { id: 2, homeTeam: 'Warriors', awayTeam: 'Heat', homeScore: 112, awayScore: 108, status: 'Final' },
    { id: 3, homeTeam: 'Bucks', awayTeam: 'Nets', homeScore: 88, awayScore: 92, status: '4th Q' },
    { id: 4, homeTeam: 'Suns', awayTeam: 'Mavs', homeScore: 0, awayScore: 0, status: '7:30 PM' },
];

const ScoresTicker = ({ refreshInterval = 30 }) => {
    const [scores, setScores] = useState(PLACEHOLDER_SCORES);

    // Placeholder: would fetch real scores on interval
    useEffect(() => {
        // In production, this would:
        // const interval = setInterval(() => fetchScores(), refreshInterval * 1000);
        // return () => clearInterval(interval);
    }, [refreshInterval]);

    return (
        <div className="scores-ticker">
            <div className="scores-ticker__track">
                {scores.map(game => (
                    <div key={game.id} className="scores-ticker__game">
                        <div className="scores-ticker__teams">
                            <span className="scores-ticker__team scores-ticker__team--away">
                                {game.awayTeam}
                            </span>
                            <span className="scores-ticker__vs">@</span>
                            <span className="scores-ticker__team scores-ticker__team--home">
                                {game.homeTeam}
                            </span>
                        </div>
                        <div className="scores-ticker__score">
                            <span className="scores-ticker__score-away">{game.awayScore}</span>
                            <span className="scores-ticker__score-separator">-</span>
                            <span className="scores-ticker__score-home">{game.homeScore}</span>
                        </div>
                        <div className="scores-ticker__status">
                            {game.status}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ScoresTicker;
